<template>
  <section class="login-container">
    <wechat-login
      v-if="showWechatLogin"
      :status.sync="wechatStatus"
      :check-unread-info="checkUnreadInfo"
      :check-login-times="checkLoginTimes"
      :auto-to-tool="autoToTool"
      @backClick="backClick"
      @loginSucc="loginSuccHdl"
    ></wechat-login>
    <div
      v-else
      class="mobile-login"
    >
      <div class="mobile-login-title">
        <p class="title-p-active">
          登录
        </p>
        <p
          class="title-p"
          @click="goTo('register')"
        >
          注册
        </p>
      </div>
      <div class="form-box">
        <!-- <div style="display:none">
                    <P>解决账号密码自动填充的问题</P> <input type="text" > <input type="password" >
                </div> -->
        <div class="form">
          <input
            ref="account"
            v-model="logindata.account"
            autocomplete="on"
            placeholder="请输入手机号/邮箱/账号"
            @focus="formatAcount"
          >
          <div
            v-if="validate.account"
            class="check-right"
          ></div>
          <p class="error">
            {{ validate.accountMsg }}
          </p>
        </div>
        <div class="form">
          <input
            v-model="logindata.psw"
            placeholder="请输入密码(6-20位数字或英文)"
            :type="pwdType"
            autocomplete="on"
            maxlength="20"
            @blur="checkPsw"
            @focus="formatPwd"
            @keyup.enter="submit"
          >
          <div
            v-if="logindata.psw"
            class="pwd-clear"
            @click="logindata.psw = ''"
          >
            <iconfont-hover
              width="10px"
              height="10px"
              initial-name="#icon-close"
              hover-name="#icon-close-hover"
              class="close-btn"
            >
            </iconfont-hover>
          </div>
          <!-- <div
                        class="pwd-show"
                        :class="{ active: idPwdShow }"
                        @click="changePwdType">
                    </div> -->
          <div @click="changePwdType">
            <iconfont-hover
              v-if="idPwdShow"
              class="pwd-show"
              width="16px"
              height="16px"
              initial-name="#icon-showpwd"
              hover-name="#icon-showpwd-hover"
            >
            </iconfont-hover>
            <iconfont-hover
              v-else
              class="pwd-show"
              width="16px"
              height="16px"
              initial-name="#icon-hidepwd"
              hover-name="#icon-hidepwd-hover"
            >
            </iconfont-hover>
          </div>
          <p class="error">
            {{ validate.pswMsg }}
          </p>
        </div>
        <div class="forget-pwd">
          <span @click="goTo('findPwd')">
            忘记密码
          </span>
        </div>
      </div>
      <button
        ref="loginBtn"
        :disabled="btnDisabled"
        :class="{ 'sbtn-disabled': btnDisabled }"
        @click="submit(false)"
        v-html="submitBtn"
      ></button>
      <div class="go-register">
        还不是来画用户？去<a @click="goTo('register')">注册</a>
      </div>
    </div>
    <div class="login-line">
      换个姿势登录
    </div>
    <div class="other-login">
      <div
        v-if="!showWechatLogin"
        class="option"
        style="margin-right: 62px;"
        @click="oauthlogin(3)"
      >
        <svg
          class="iconfont signinicon1"
          aria-hidden="true"
        >
          <use xlink:href="#icon-sign-wechat"></use>
        </svg>
      </div>
      <div
        class="option"
        style="margin-right: 62px;"
        @click="oauthlogin(1)"
      >
        <svg
          class="iconfont signinicon2"
          aria-hidden="true"
        >
          <use xlink:href="#icon-signin-weibo"></use>
        </svg>
      </div>
      <div
        class="option"
        @click="oauthlogin(2)"
      >
        <svg
          class="iconfont signinicon3"
          aria-hidden="true"
        >
          <use xlink:href="#icon-signin-qq"></use>
        </svg>
      </div>
    </div>
  </section>
</template>
<script>
// eslint-disable
/* eslint-disable */
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'LoginDialog',
  components: {
    wechatLogin: () => import('./wechatLogin')
  },
  props: {
    wechatStatus: {
      type: Boolean,
      default: false
    }
  },
  loginType: {
    type: String,
    default: 'mobile'
  },
  data() {
    return {
      idPwdShow: false, //密码显示控制
      pwdType: 'password',
      weChatLogin: false, // 默认微信登录
      mobileLogin: true,
      logindata: {
        account: '',
        psw: ''
      },
      validate: {
        //校验
        account: false,
        psw: false,
        accountMsg: '',
        pswMsg: ''
      },
      submitBtn: '登&nbsp;录',
      btnDisabled: true,
      isAc: 0, //是否在pc端大赛页面发起登录,0普通，1pc大赛，2app大赛
      adData: null, // 活动数据
      showWechatLogin: false // 微信登录
    }
  },
  computed: {
    ...mapGetters(['loginStatus', 'countDownInfo', 'routeParam']),
    showAdImg() {
      if (this.adData) {
        var nowTime = new Date().getTime()
        return this.adData.startTime * 1000 < nowTime && this.adData.endTime * 1000 > nowTime
      } else {
        return false
      }
    }
  },
  watch: {
    wechatStatus(val) {
      //关闭dialog清空数据
      if (!val) {
        this.closeHdl()
        this.beforeClose()
      }
    },
    logindata: {
      handler: function(val, oldVal) {
        this.btnDisabled = val.account == '' || val.psw == ''
      },
      deep: true
    }
  },
  mounted() {
    this.fetchBanner()
  },
  beforeDestroy() {
    this.closeHdl()
    this.beforeClose()
  },
  methods: {
    ...mapMutations(['changeLogin', 'changeLoginVisible', 'changeUnreadMsgInfo']),
    closeHdl() {
      // 去除掉url上自动跳转相关的参数
      if (!this.loginStatus) {
        let path = this.$route.path
        let query = Object.assign({}, this.$route.query)
        let skipParam = ['login', 'url', 'template']
        // 如果当前路由没有[登录自动跳转]相关的参数（login和url),不作任何操作
        if (!Object.keys(query).includes('login') || !Object.keys(query).includes('url')) return

        Object.keys(query).map((p) => {
          if (skipParam.indexOf(p) !== -1) {
            delete query[p]
          }
        })
        this.$router.push({ path, query })
      }
      if (/payment|userCenter/gi.test(this.$route.name)) {
        this.loginStatus ? (this.wechatStatus = false) : this.$router.push('/')
        return
      }
    },
    // 关闭弹窗前处理数据
    beforeClose() {
      // console.log("退出登录前清空数据");
      this.changeLoginVisible(false)
      this.logindata.account = ''
      this.logindata.psw = ''
      this.validate.account = false
      this.validate.psw = false
      this.validate.accountMsg = ''
      this.validate.pswMsg = ''
      this.submitBtn = '登&nbsp;录'
    },
    loginSuccHdl() {
      this.$bus.emit('bus::wechatLogin')
      this.changeLoginVisible(false)
    },
    formatAcount(value) {
      this.validate.account = false
      this.validate.accountMsg = ''
      return value
    },
    formatPwd(value) {
      this.validate.psw = false
      this.validate.pswMsg = ''
      return value
    },
    //显示隐藏密码
    changePwdType() {
      this.idPwdShow = !this.idPwdShow
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
    },
    //校验账号是否注册和是否正确
    checkAccount() {
      if (!this.logindata.account.length) {
        this.validate.accountMsg = '请输入手机号或邮箱'
        return
      }
      let email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      let phone = /^(0|86|17951|12593)?((13[0-9])|(14[014]0[0-9])|(14[5-9])|(15([0-3]))|(15([5-9]))|(16[2567])|(170[0-9])|(174[0-5])|(17[1235678])|(18[0-9])|(19[012356789]))\d{8}$/
      if (email.test(this.logindata.account)) {
        // console.log('邮箱')
      } else if (phone.test(this.logindata.account)) {
        // console.log('手机')
      } else {
        this.validate.accountMsg = '请输入正确手机号码或邮箱'
        this.validate.account = false
        return
      }
      //请求判断账号是否已经注册
      this.$http
        .get('/user/account?acc=' + this.logindata.account)
        .then((response) => {
          var _data = response.data
          if (_data.code == 200) {
            this.validate.account = true
          } else {
            this.validate.accountMsg = _data.msg
            this.validate.account = false
          }
        })
        .catch(function(error) {
          //   console.log(error, '失败')
        })
    },
    //校验密码格式是否正确
    checkPsw() {
      if (!this.logindata.psw.length) {
        this.validate.pswMsg = '请输入密码'
        this.validate.psw = false
      } else if (this.logindata.psw.length < 6) {
        this.validate.pswMsg = '密码不能少于6位'
        this.validate.psw = false
      } else if (this.logindata.psw.length > 20) {
        this.validate.pswMsg = '密码不能大于20位'
        this.validate.psw = false
      } else {
        this.validate.pswMsg = ''
        this.validate.psw = true
      }
    },
    //提交
    submit(ev) {
      if (ev)
        if (~~ev.keyCode != 13) {
          // console.log(this.logindata, 'ok', this.alertMsg,ev.keyCode)
          return
        }
      if (!this.logindata.account.length) {
        this.validate.accountMsg = '请输入手机号或邮箱'
        return
      }
      this.checkPsw()
      if (!this.validate.psw) {
        return
      }
      this.submitBtn = '登录中...'
      this.btnDisabled = true
      this.$http
        .post('/login', this.logindata)
        .then((response) => {
          var _data = response.data
          // 登录成功
          if (_data.code == 200) {
            // console.log("账号信息",_data.data,"-------")
            this.checkLoginTimes(_data.data)
            this.changeLogin(_data.data)
            this.autoToTool()
            this.checkUnreadInfo()
            this.changeLoginVisible(false)
            this.$bus.emit('bus::logged', _data.data)
            // 神策方法
            this.$sensors.login(_data.data.id)
            this.doBroadcast()
          } else if (_data.code == 416) {
            this.validate.pswMsg = _data.msg
            this.validate.psw = false
          } else {
            this.validate.accountMsg = _data.msg
          }
          this.btnDisabled = false
          this.submitBtn = '登&nbsp;录'
        })
        .catch((error) => {
          this.submitBtn = '登&nbsp;录'
          this.btnDisabled = false
        })
      // 点击注册、登录按钮
      // this.$store.commit('sensors/registerLoginButtonClick2Sensor')
    },
    // 用户登录信息发生变化时通知编辑器
    doBroadcast() {
      const bc = new BroadcastChannel('laihua')
      bc.postMessage({ userID: this.$store.getters.userInfo.id })
    },
    //跳转到页面
    goTo(str) {
      this.$emit('goto', str)
      this.changeLoginVisible(false)
    },
    // 登陆成功后自动跳转到工具
    autoToTool() {
      if (Object.keys(this.$route.query).indexOf('login') != -1) {
        // 路由参数带有url
        let url = decodeURI(this.$route.query.url)
        if (url != 'undefined') {
          window.location.href = url
          return
        }

        // 路有参数中带‘storaBoard'：在故事版点击下一步
        let storyboard = this.$route.query.storyBoard === undefined ? '' : 'storyBoard'
        if (storyboard) {
          window.location.href = window.location.origin + `/tool?${storyboard}`
        }

        // 路由参数带’template'：模板上点击使用
        let checkId = this.$route.query.template === undefined ? '' : this.$route.query.template
        if (checkId) {
          window.location.href = window.location.origin + `/tool?template=${checkId}`
        }
      }
    },
    //判断用户是否第一次登陆，不同的账号存为不同的对象。
    checkLoginTimes(userData) {
      var hasNewTag = true
      var tempUsers = {}
      var localUsers = localStorage.getItem('localUsers')
      if (!localUsers) {
        localUsers = [{ loginTimes: 0, id: userData.id }]
        localStorage.setItem('localUsers', JSON.stringify(localUsers))
      } else {
        localUsers = JSON.parse(localUsers)
        // console.log("localUsers",localUsers,"-----",typeof(localUsers),"----")
        var arrLen = localUsers.length
        for (let i = 0; i < arrLen; i++) {
          if (userData.id != localUsers[i].id) {
            tempUsers.loginTimes = 0
            tempUsers.id = userData.id
          } else {
            hasNewTag = false
          }
        }
        if (hasNewTag) {
          localUsers.push(tempUsers)
        }
        localStorage.setItem('localUsers', JSON.stringify(localUsers))
      }
    },
    /**
     * 获取未读信息状态
     */
    checkUnreadInfo() {
      this.$http
        .get('/user/inform/unreadInform')
        .then(({ data }) => {
          if (data.code == 200) {
            // this.changeUnreadMsgInfo(data.data[0].total)
          } else {
            // console.log(`获取未读信息数量失败:`,data.data);
          }
        })
        .catch((err) => {
          // console.log(`err:`,err);
        })
    },
    // 获取登录底部弹窗banner
    fetchBanner() {
      this.$http.get('/home/banner?type=1&category=17').then((data) => {
        if (data.data.code == 200) {
          this.adData = data.data.data && data.data.data[0]
        }
      })
    },
    // 底部弹窗banner链接到的页面
    linkAd(page) {
      if (!page) return
      window.open(page)
    },
    // 微信登录的返回按钮
    backClick() {
      this.showWechatLogin = false
      console.log('点击微信登录返回按钮')
    },
    //其他登录方式
    oauthlogin(val) {
      this.setCookie()
      this.setRouteURL()
      const registerSuccessSource = this.$store.getters['sensors/registerSuccessSource']
      const source = registerSuccessSource ? registerSuccessSource.name : '非指定来源'
      let utmParam = this.$.storage.get('utmParam') || this.routeParam || ''
      switch (val) {
        case 1: // 微博
          var _href = `/webapi/login/weibo?${utmParam}&isAc=${this.isAc}&source=${source}`
          this.openLink(_href)
          break
        case 2: // qq
          _href = `/webapi/login/qq?${utmParam}&isAc=${this.isAc}&source=${source}`
          this.openLink(_href)
          break
        case 3: //微信
          // window.location.href = `/login/wechat?${
          //     utmParam ? utmParam : ""
          // }&isAc=${this.isAc}`;
          this.showWechatLogin = true
          break
      }
      this.checkUnreadInfo()
    },
    openLink(src) {
      let link = document.createElement('a')
      link.target = '_blank'
      link.href = src
      link.click()
    },
    setCookie() {
      let uuid = this.$.generateUuid()
      document.cookie = `laihuatemporarycookie=${uuid}`
    },
    //设置第三方登录存储路由地址
    setRouteURL() {
      // 设置第三方登录后需要跳转到哪个地址
      var toPath = this.$route.name && this.$route.name.includes('wbsignin') ? '/workbench' : window.location.pathname
      sessionStorage.setItem('routeURL', toPath)
      sessionStorage.setItem('routeSearch', window.location.search)
    }
  }
}
</script>
<style lang="scss">
.login-container {
  width: 302px;
  margin: 0 auto;
  border-radius: 5px;
  box-sizing: border-box;
  overflow: hidden;
  .dialog-title {
    font-size: 18px;
  }
  .mobile-login {
    width: 300px;
    box-sizing: border-box;
    &-title {
      display: flex;
      flex-direction: row;
      p {
        font-size: 18px;
        cursor: pointer;
      }
      .title-p-active {
        margin-right: 25px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        padding-bottom: 6px;
        border-bottom: 3px solid #2f58fe;
      }
    }
    .form-box {
      font-size: 12px;
      position: relative;
      margin-top: 22px;
      .forget-pwd {
        margin-top: -12px;
        margin-bottom: 12px;
        text-align: right;
        span {
          color: #666666;
          text-decoration: underline;
          cursor: pointer;
          &:hover {
            color: #5779fa;
          }
        }
      }
    }

    .form {
      position: relative;
      margin: 0 auto 20px;
      width: 299px;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      border: 1px solid #d4d2da;
      border-radius: 4px;
      label {
        margin-right: 24px;
      }
      input {
        padding-left: 10px;
        width: 90%;
        font-size: 14px;
      }
      input:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
      }
      input::placeholder {
        color: #c7c7c7;
        font-size: 14px;
      }
      .pwd-clear {
        height: 23px;
        position: absolute;
        right: 26px;
        top: 8px;
        cursor: pointer;
      }
      .pwd-show {
        width: 23px;
        height: 23px;
        // transform: scale(0.66);
        // background: url("../../assets/img/icon_15/logcomp/pwd-hide.png")
        //     no-repeat center / contain;
        cursor: pointer;
        position: absolute;
        right: 2px;
        top: 8px;
        // &.active {
        //     background: url("../../assets/img/icon_15/logcomp/pwd-show.png")
        //         no-repeat center / contain;
        // }
      }
      .check-right {
        width: 23px;
        height: 23px;
        transform: scale(0.66);
        background: url(./icons/check-right.png) no-repeat center / contain;
        position: absolute;
        right: -20px;
        top: 8px;
      }
      .error {
        padding-left: 5px;
        color: #ff1f2a;
        font-size: 14px;
        position: absolute;
        bottom: -20px;
      }
    }
    button {
      width: 300px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      border-radius: 4px;
      border: none;
      background-color: #5779fa;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      &.sbtn-disabled {
        background-color: #ddd;
        cursor: not-allowed;
      }
    }
    .other-login {
      margin-top: 55px;
      > div {
        width: 33.3%;
      }
    }
  }
  .go-register {
    margin-top: 11px;
    font-size: 12px;
    text-align: left;
    color: #666;
    a {
      color: #5779fa;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .login-line {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 300px;
    margin-top: 40px;
    margin-bottom: 21px;
    line-height: 14px;
    font-size: 14px;
    color: #999999;
    &::after {
      position: absolute;
      width: 92px;
      height: 1px;
      right: 0px;
      bottom: 50%;
      content: '';
      background-color: #e4e4e4;
    }
    &::before {
      position: absolute;
      width: 92px;
      height: 1px;
      left: 0px;
      bottom: 50%;
      content: '';
      background-color: #e4e4e4;
    }
  }
  .other-login {
    display: flex;
    justify-content: center;
    position: relative;
    width: 300px;
    .option {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      border: 1px solid #e4e4e4;
      .signinicon1 {
        cursor: pointer;
        width: 30px;
        height: 25px;
      }
      .signinicon2 {
        cursor: pointer;
        width: 30px;
        height: 25px;
      }
      .signinicon3 {
        cursor: pointer;
        width: 24px;
        height: 29px;
      }
      &:hover {
        background-color: #f5f5f5;
      }
    }
  }
}
</style>
